import { gettext } from '@/translations/gettext.setup';

const { $gettext } = gettext;

const noDataFilter = (value) => {
  if (!value && value !== 0) return $gettext('no data');
  return value;
};

export default noDataFilter;